import { useCallback, useEffect, useRef, useState } from 'react';
import { getFriendsActivity } from '../api/FriendsAPI';
import { useSocket } from '../socket/SocketContext';

const REFETCH_DEBOUNCE_MS = 500;
const POLL_MS = 60 * 1000;

// Which friends are in voice, and where (see getFriendsActivity). Refetched
// when the server says a friend moved or what's playing changed
// (friends:activityChanged), when the friend list changes, and once a
// minute as a fallback while the window is visible.
export function useFriendsActivity() {
  const { socket, connected } = useSocket();
  const [voice, setVoice] = useState({});
  const timer = useRef(null);

  const load = useCallback(async () => {
    const res = await getFriendsActivity().catch(() => null);
    if (res && res.status === 'success') setVoice(res.data);
  }, []);

  const soon = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(load, REFETCH_DEBOUNCE_MS);
  }, [load]);

  useEffect(() => {
    load();
    const poll = setInterval(() => {
      if (document.visibilityState === 'visible') load();
    }, POLL_MS);
    return () => {
      clearInterval(poll);
      clearTimeout(timer.current);
    };
  }, [load]);

  useEffect(() => {
    const s = socket && socket.current;
    if (!s) return undefined;
    const events = ['friends:activityChanged', 'friends:changed', 'friendRequestAccepted'];
    events.forEach((e) => s.on(e, soon));
    return () => events.forEach((e) => s.off(e, soon));
    // `connected`: attach once the socket exists (see Friends.js).
  }, [socket, connected, soon]);

  return voice;
}
